<template>
  <div class="page-wrap">
    <div class="validate-wrap">
      <h1>{{$t('adminApproval.title')}}</h1>
      <div class="no-data" v-if="areUsersEmpty">{{$t('adminApproval.noData')}}</div>
      <div class="view" v-if="usersForValidation.length !== 0 || usersRejected.length !== 0">
        <div class="menu-validation">
          <label
            for="for-validation"
          >{{$t('adminApproval.titleApproval') + ` (${usersForValidation.length})`}}</label>
          <input
            type="radio"
            id="for-validation"
            name="view"
            value="pendingApproval"
            v-model="view"
          />
        </div>
        <div class="menu-rejected">
          <label for="declined">{{$t('adminApproval.titleRejected') + ` (${usersRejected.length})`}}</label>
          <input type="radio" id="declined" name="view" value="declined" v-model="view" />
        </div>
      </div>

      <div class="search-user">
        <input type="text" id="searchUser" placeholder="Search..." v-model="searchValue" />
        <button @click="init">
          {{$t('button.refresh')}}
          <span class="material-icons refresh">refresh</span>
        </button>
      </div>

      <each-user
        v-for="user in users"
        :key="user.usr_id"
        :user="user"
        :view="view"
        @set-user-id="setUserId"
        @validate="validateUser"
        @reject="confirmAction(rejectUser, $t('adminApproval.rejectUserQuestion'), 'Reject')"
      ></each-user>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import EachUser from "../../components/admin/approval/EachUser.vue";
import AdminMixin from './adminMixin';
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    EachUser
  },
  data() {
    return {
      usersForValidation: [],
      usersRejected: [],
      areUsersEmpty: false,
      searchValue: "",
      view: "pendingApproval",
      usrId: null,
      searchTimeout: null
    };
  },
  computed: {
    users () {
      return this.view === "pendingApproval"? this.usersForValidation: this.usersRejected;
    },
  },
  watch: {
    searchValue: {
      handler () {
        if (this.searchTimeout) {
          clearInterval(this.searchTimeout);
          this.searchTimeout = null;
        }
        this.searchTimeout = setTimeout(() => {
          this.init();
          this.searchTimeout = null;
        }, 500);
      },
    },
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.startLoading();
        this.usersForValidation = await this.getUsers(api.getUsersAwaitingValidation);
        this.usersRejected = await this.getUsers(api.getRejectedUsers);
        this.ifUsersEmpty();
      this.stopLoading();
    },
    async getUsers (api) {
      let apiObj = {
        api: api,
        params: {
          search: this.searchValue
        },
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);
      return data.data;
    },
    ifUsersEmpty () {
      if (
        this.usersForValidation.length === 0 &&
        this.usersRejected.length === 0
      ) {
        this.areUsersEmpty = true;
      } else {
        this.areUsersEmpty = false;
      }
    },
    setUserId (usrId) {
      this.usrId = usrId;
    },
    async validateUser () {
      this.callApiShowSuccessMessageGetData(api.validateUser, this.$t("adminApproval.userApproved"));
    },
    async rejectUser () {
      this.callApiShowSuccessMessageGetData(api.rejectUser, this.$t("adminApproval.userRejected"));
    },
    async callApiShowSuccessMessageGetData (callback, successMessage) {
      let apiObj = {
        api: callback,
        params: {
          usr_id: this.usrId
        },
        onError: () => this.stopLoading()
      }
      this.startLoading();
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage(successMessage);
          await this.init();
        }
      this.stopLoading();
    }
  }
};
</script>

<style scoped lang="scss">
label {
  cursor: pointer;
}
h1 {
  margin: 30px 0 40px 0;
  font-size: 30px;
  line-height: 35px;
}
.page-wrap {
  background-color: #e5e5e5;
  display: flex;
  justify-content: center;
}
.validate-wrap {
  width: 70%;
  text-align: center;
}
.search-user input:focus {
  border: none;
  outline: none;
}
.search-user {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin: 2% 0;
}
.search-user input {
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 30%;
}
.search-user button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  font-size: 1em;
  box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 13px;
  font-weight: 600;
  position: relative;
  margin-left: 10px;
  padding: 10px 35px 10px 12px;
  background-color: #21eb99;
  color: white;
}
.search-user button:focus {
  border: none;
  outline: none;
}
.material-icons.refresh {
  position: absolute;
  right: 5px;
  top: 5px;
}
.view {
  display: flex;
  flex-direction: row;
}
.view div {
  margin-left: 15%;
}
.view label {
  font-size: 2em;
}
.view input {
  box-shadow: none;
}
input[type="radio"]:active,
input[type="radio"]:focus {
  outline: none;
  border: none;
}
</style>